import { useTranslation } from "react-i18next";

/**
 * Resolves the (data-driven) placeholder-page title/description keys to translated text.
 * Listed as literal `t("…")` here (the useXxxLabel pattern) so i18next-parser keeps the
 * keys — `t(titleKey)` / `t(descriptionKey)` alone would get pruned from the locale files.
 */
export const usePlaceholderLabel = () => {
  const { t } = useTranslation();
  const labels: Record<string, string> = {
    Overview: t("Overview"),
    "New need": t("New need"),
    "My needs": t("My needs"),
    "Needs overview": t("Needs overview"),
    "Market surveys": t("Market surveys"),
    "New procurement": t("New procurement"),
    "All contracts": t("All contracts"),
    "Active contracts": t("Active contracts"),
    Profile: t("Profile"),
    Settings: t("Settings"),
    Templates: t("Templates"),
    Users: t("Users"),
    "Your procurement activity at a glance.": t("Your procurement activity at a glance."),
    "Register a new procurement need.": t("Register a new procurement need."),
    "Needs you have registered.": t("Needs you have registered."),
    "All registered needs.": t("All registered needs."),
    "Explore the market before you buy.": t("Explore the market before you buy."),
    "Start a new sourcing event.": t("Start a new sourcing event."),
    "All your contracts.": t("All your contracts."),
    "Contracts currently in effect.": t("Contracts currently in effect."),
    "Your personal profile.": t("Your personal profile."),
    "Manage your settings.": t("Manage your settings."),
    "Document templates.": t("Document templates."),
    "Manage users and access.": t("Manage users and access."),
  };
  return (key: string): string => labels[key] ?? key;
};
